import styles from "./style.module.css";
import { Box, Grid, Typography, Button } from "@mui/material";
import { useEffect, useState } from "react";
import AdminApi from "../../../config/apis/admin";
import { api } from "../../../config/apis";
import { DataLoader } from "../../../helper/helperFunction";

export const DasboardActiveCards = (params) => {
  const [SCTData, setSCTDATA] = useState();
  const [loading, setLoading] = useState(true);
  const filterActive =
    params.filterData.phase_id || params.filterData.cohort_id;

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await api.get(AdminApi.ACTIVE_SCT_COUNT, {
          params: {
            filters: {
              ...params.filterData,
            },
          },
        });
        setSCTDATA(res.data.data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [params.filterData]);
  // Handler for Active Students CSV download
  const handleActiveStudentsClick = () => {
    if (!SCTData || !SCTData.student_list) return;

    // CSV header
    let csvContent = "ID,First Name,Last Name,Email,Cohort,Section,Registration Date\n";

    // Add data rows
    SCTData.student_list.forEach((student) => {
      csvContent += `${escapeCSV(student.id)},${escapeCSV(
        student.first_name
      )},${escapeCSV(student.last_name)},${escapeCSV(
        student.email
      )},${escapeCSV(student.cohort)},${escapeCSV(
        student.section
      )},${escapeCSV(formatDate(student.registration_date))}\n`;
    });

    downloadCSV(csvContent, "active_students.csv");
  };

  // Handler for Active Courses CSV download
  const handleActiveCoursesClick = () => {
    if (!SCTData || !SCTData.course_list) return;

    // CSV header
    let csvContent = "ID,Title\n";

    // Add data rows
    SCTData.course_list.forEach((course) => {
      csvContent += `${escapeCSV(course.id)},${escapeCSV(course.title)}\n`;
    });

    downloadCSV(csvContent, "active_courses.csv");
  };

  // Handler for Active Teachers CSV download
  const handleActiveTeachersClick = () => {
    if (!SCTData || !SCTData.teacher_list) return;

    // CSV header
    let csvContent = "ID,First Name,Last Name,Email,Cohort,Section,Registration Date\n";

    // Add data rows
    SCTData.teacher_list.forEach((teacher) => {
      csvContent += `${escapeCSV(teacher.id)},${escapeCSV(
        teacher.first_name
      )},${escapeCSV(teacher.last_name)},${escapeCSV(
        teacher.email
      )},${escapeCSV(teacher.cohort)},${escapeCSV(teacher.section)},${escapeCSV(formatDate(teacher.registration_date))}\n`;
    });

    downloadCSV(csvContent, "active_teachers.csv");
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  // Helper function to escape CSV values
  const escapeCSV = (value) => {
    if (value === null || value === undefined) return "";

    // Convert to string and check if we need to wrap in quotes
    const stringValue = String(value);
    if (
      stringValue.includes(",") ||
      stringValue.includes('"') ||
      stringValue.includes("\n")
    ) {
      // Escape quotes by doubling them and wrap in quotes
      return `"${stringValue.replace(/"/g, '""')}"`;
    }
    return stringValue;
  };

  // Common download function
  const downloadCSV = (csvContent, fileName) => {
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", fileName);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      {loading ? (
        <DataLoader />
      ) : (
        <>
          <Grid
            container
            spacing={3}
            className={styles.totalJobsContainer_wrap}
          >
            <Grid item xs={12} lg={4}>
              <Box
                className={`${styles.totalJobsContainer}`}
                onClick={handleActiveStudentsClick}
                style={{ cursor: "pointer" }}
              >
                <Box className={styles.left_box}>
                  <Typography variant="h6">
                    Active Students {filterActive ? "**" : ""}
                  </Typography>
                  <Typography variant="h4">
                    {SCTData && SCTData.active_students}
                  </Typography>
                </Box>
                <Box className={styles.imageContainer}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="35"
                    height="35"
                    viewBox="0 0 35 35"
                    fill="none"
                  >
                    <path
                      d="M29.7023 17.9357C29.6085 17.8988 27.373 17.0298 24.7031 16.8692C22.1973 16.7182 20.1324 17.24 18.5977 18.3918V34.1187C19.7151 32.3374 21.7119 31.5153 24.5394 31.6756C26.901 31.8095 28.9536 32.6027 28.9732 32.6103C29.2798 32.731 29.6262 32.692 29.8986 32.5066C30.1709 32.321 30.3339 32.0128 30.3339 31.6833V18.8627C30.3338 18.4532 30.0833 18.0855 29.7023 17.9357ZM27.0582 26.5325C27.0085 27.0805 26.5238 27.4843 25.9763 27.4347C24.9041 27.3376 23.9246 27.3776 23.0652 27.5535C22.3046 27.7089 21.9459 27.0525 21.8895 26.7774C21.7792 26.2385 22.1267 25.7122 22.6656 25.6018C23.7156 25.3868 24.89 25.336 26.1561 25.4506C26.7039 25.5003 27.1078 25.9847 27.0582 26.5325ZM27.0582 22.259C27.0086 22.8069 26.5238 23.2108 25.9763 23.1612C24.9052 23.0641 23.9257 23.1043 23.0651 23.2805C22.3045 23.436 21.9458 22.7795 21.8895 22.5044C21.7791 21.9654 22.1266 21.4391 22.6656 21.3287C23.7168 21.1136 24.8911 21.0626 26.156 21.1771C26.7039 21.2267 27.1078 21.711 27.0582 22.259Z"
                      fill="#FFFFFF"
                    />
                    <path
                      d="M10.5018 16.8694C7.83195 17.03 5.59645 17.899 5.50262 17.9359C5.12158 18.0857 4.87109 18.4534 4.87109 18.8628V31.6836C4.87109 32.0131 5.03405 32.3213 5.30639 32.5068C5.57879 32.6923 5.92523 32.7312 6.23182 32.6105C6.25188 32.6026 8.26372 31.8204 10.6215 31.6784C13.4718 31.5069 15.4839 32.328 16.6073 34.1189V18.392C15.0725 17.2403 13.0074 16.7187 10.5018 16.8694ZM13.3154 26.7776C13.2591 27.0526 12.9004 27.7091 12.1398 27.5537C11.2804 27.3778 10.301 27.3377 9.22867 27.4349C8.68122 27.4845 8.19639 27.0807 8.14678 26.5327C8.09718 25.9849 8.50106 25.5005 9.04898 25.4508C10.3151 25.3361 11.4895 25.387 12.5394 25.602C13.0783 25.7123 13.4258 26.2387 13.3154 26.7776ZM13.3154 22.5045C13.2591 22.7796 12.9005 23.4361 12.1398 23.2806C11.2792 23.1044 10.2997 23.0642 9.22861 23.1613C7.90964 23.2314 7.73931 21.3446 9.04891 21.1772C10.3138 21.0627 11.4881 21.1137 12.5394 21.3288C13.0783 21.4392 13.4258 21.9656 13.3154 22.5045Z"
                      fill="#FFFFFF"
                    />
                    <path
                      d="M17.6034 8.58343C19.9371 8.58343 21.8357 6.68481 21.8357 4.35116C21.6229 -1.25585 13.583 -1.25432 13.3711 4.35123C13.3712 6.68481 15.2697 8.58343 17.6034 8.58343Z"
                      fill="#FFFFFF"
                    />
                    <path
                      d="M6.93149 11.2497C9.2652 11.2497 11.1638 9.35107 11.1638 7.01742C10.951 1.41041 2.91112 1.41194 2.69922 7.01749C2.69922 9.35114 4.59777 11.2497 6.93149 11.2497Z"
                      fill="#FFFFFF"
                    />
                    <path
                      d="M28.2714 11.2497C30.6051 11.2497 32.5037 9.35107 32.5037 7.01742C32.2909 1.41041 24.251 1.41194 24.0391 7.01749C24.0391 9.35114 25.9377 11.2497 28.2714 11.2497Z"
                      fill="#FFFFFF"
                    />
                    <path
                      d="M23.931 13.2282C23.931 11.6276 23.0416 10.1891 21.6103 9.47419L21.3278 9.33301C19.2569 10.9728 15.9445 10.9728 13.8735 9.33361L13.5888 9.47598C12.1582 10.192 11.2695 11.6303 11.2695 13.2299V14.8521C13.0337 14.8461 15.4697 15.1506 17.6002 16.654C19.7307 15.1503 22.1661 14.8459 23.931 14.852V13.2282Z"
                      fill="#FFFFFF"
                    />
                    <path
                      d="M32.279 12.1404L31.9965 11.9993C30.3713 13.2767 27.8423 13.6185 25.9062 12.7756C25.9171 12.9253 25.9227 13.0763 25.9227 13.2283V14.9826C28.3366 15.2805 30.1982 15.9909 30.4294 16.0818C31.5805 16.5345 32.3241 17.6261 32.3241 18.8628V21.3157H33.6036C34.1537 21.3157 34.5997 20.8697 34.5997 20.3196V15.8945C34.5997 14.2939 33.7103 12.8554 32.279 12.1404Z"
                      fill="#FFFFFF"
                    />
                    <path
                      d="M9.2786 13.2297C9.2786 13.0772 9.28425 12.9257 9.29514 12.7754C7.35913 13.6182 4.83091 13.2767 3.20548 11.9998L2.9208 12.1421C1.49028 12.8581 0.601562 14.2965 0.601562 15.8959V20.3195C0.601562 20.8696 1.04755 21.3156 1.59766 21.3156H2.87711V18.8626C2.87711 17.626 3.62079 16.5344 4.77174 16.0817C5.0031 15.9908 6.8646 15.2804 9.2786 14.9825V13.2297Z"
                      fill="#FFFFFF"
                    />
                  </svg>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} lg={4}>
              <Box
                className={`${styles.totalJobsContainer}`}
                onClick={handleActiveCoursesClick}
                style={{ cursor: "pointer" }}
              >
                <Box className={styles.left_box}>
                  <Typography variant="h6">
                    Active Courses {filterActive ? "**" : ""}
                  </Typography>
                  <Typography variant="h4">
                    {SCTData && SCTData.active_courses}
                  </Typography>
                </Box>
                <Box className={styles.imageContainer}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                    fill="none"
                  >
                    <path
                      d="M6.32013 14.512L17.9544 21.4891L35.3971 11.0235L17.9544 0.557861L0.511719 11.0235H17.9544V14.512H6.32013ZM0.511719 14.512V28.4662L4.00026 24.5939V16.6051L0.511719 14.512ZM17.9544 35.4432L9.23306 30.2104L5.74452 28.1173V17.6517L17.9544 24.9776L30.1643 17.6517V28.1173L17.9544 35.4432Z"
                      fill="white"
                    />
                  </svg>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} lg={4}>
              <Box
                className={`${styles.totalJobsContainer}`}
                onClick={handleActiveTeachersClick}
                style={{ cursor: "pointer" }}
              >
                <Box className={styles.left_box}>
                  <Typography variant="h6">
                    Active Teachers {filterActive ? "**" : ""}
                  </Typography>
                  <Typography variant="h4">
                    {SCTData && SCTData.active_teachers}
                  </Typography>
                </Box>
                <Box className={styles.imageContainer}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="35"
                    height="34"
                    viewBox="0 0 35 34"
                    fill="none"
                  >
                    <path
                      d="M34.1198 20.8053H22.1529C22.1435 20.9545 22.1286 21.0794 22.1278 21.2044C22.1255 21.8416 22.1403 22.4796 22.1223 23.1168C22.1066 23.6775 22.0878 24.1171 22.777 24.4342C23.6474 24.834 23.95 26.0132 23.6215 26.9182C23.2985 27.8092 22.3552 28.4324 21.4558 28.3473C20.3965 28.2481 19.5834 27.5234 19.4274 26.5395C19.2729 25.5641 19.7896 24.6044 20.7047 24.2257C20.9446 24.1265 21.041 24.0141 21.0348 23.7454C21.0152 22.8872 21.0285 22.0282 21.0261 21.1692C21.0261 21.0552 21.012 20.9412 21.0026 20.8022H12.6081V17.0406C13.7011 17.0406 14.7934 17.0461 15.8848 17.0383C16.3757 17.0351 16.5772 16.8298 16.5795 16.3472C16.5842 15.3976 16.5842 14.4472 16.5795 13.4977C16.5772 13.0018 16.3953 12.8183 15.8903 12.8152C14.9368 12.8089 13.9826 12.8081 13.0291 12.8152C12.5218 12.8191 12.3548 12.9963 12.3493 13.5031C12.3454 13.8663 12.3493 14.2286 12.3156 14.619C11.635 13.2954 10.5922 12.4638 9.08984 12.2295C11.7346 10.0758 12.2035 7.55736 10.5451 4.60087C10.7019 4.59384 10.8392 4.58291 10.9764 4.58291C18.5272 4.58212 26.0781 4.58525 33.6297 4.57275C34.0273 4.57275 34.13 4.67271 34.1292 5.06941C34.1151 10.1562 34.1198 15.2438 34.1198 20.3305V20.8038V20.8053ZM30.2291 6.53516H17.9031V7.59172H30.2291V6.53516ZM30.2322 8.7084H17.8741C17.8741 8.92315 17.8968 9.10666 17.8694 9.28315C17.8066 9.69156 17.9799 9.77667 18.3673 9.77511C22.1694 9.76106 25.9707 9.76652 29.7727 9.76574C29.9225 9.76574 30.0731 9.75012 30.2322 9.74075V8.70918V8.7084ZM30.2322 15.4421C30.048 15.4421 29.8817 15.4421 29.7163 15.4421C25.9809 15.4421 22.2462 15.4405 18.5108 15.4437C17.7831 15.4437 17.9039 15.3523 17.8654 16.0942C17.8466 16.4698 17.9862 16.5424 18.3328 16.5416C22.1592 16.5307 25.9856 16.5346 29.8127 16.5338C29.9499 16.5338 30.0872 16.5182 30.2322 16.5096V15.4429V15.4421ZM17.9039 14.366H30.222V13.3352H17.9039V14.366ZM12.3501 8.11101C12.3501 8.60532 12.3462 9.09963 12.3517 9.59395C12.3564 10.0375 12.5501 10.2476 12.9892 10.2522C13.9685 10.2616 14.9486 10.2608 15.928 10.2522C16.3733 10.2483 16.578 10.0422 16.5803 9.60566C16.5866 8.63031 16.5866 7.65419 16.5803 6.67884C16.5772 6.25403 16.378 6.051 15.9585 6.04787C14.9659 6.04085 13.9732 6.04085 12.9805 6.04787C12.5532 6.05022 12.3587 6.24622 12.3525 6.66713C12.3454 7.14816 12.3509 7.62998 12.3509 8.11101H12.3501Z"
                      fill="white"
                    />
                    <path
                      d="M0.98542 19.4222C0.98542 18.3547 0.983068 17.288 0.98542 16.2205C0.989341 14.5463 2.21959 13.3156 3.90618 13.3078C5.4485 13.3007 6.99003 13.3007 8.53235 13.3078C10.2025 13.3156 11.4508 14.5064 11.4719 16.169C11.4994 18.3422 11.4978 20.5163 11.4727 22.6887C11.4539 24.352 10.208 25.5562 8.54489 25.5648C7.00257 25.5726 5.46104 25.5726 3.91872 25.5648C2.20234 25.5562 0.988557 24.3341 0.98542 22.6231C0.983852 21.5556 0.98542 20.4889 0.98542 19.4214V19.4222Z"
                      fill="white"
                    />
                    <path
                      d="M8.12575 0.922852H34.9912V3.49123C34.8423 3.49123 34.6925 3.49123 34.5435 3.49123C26.2972 3.49123 18.0516 3.48733 9.80528 3.50217C9.40069 3.50217 9.13331 3.2679 8.7985 3.15779C8.18377 2.95475 8.03871 2.56587 8.11712 1.98253C8.16182 1.65065 8.12496 1.30784 8.12496 0.923632L8.12575 0.922852Z"
                      fill="white"
                    />
                    <path
                      d="M10.4079 7.73923C10.4079 10.0499 8.54645 11.9014 6.22317 11.9014C3.9289 11.9014 2.04942 10.0515 2.03139 7.77203C2.01257 5.45744 3.93204 3.5497 6.26943 3.55985C8.54331 3.56923 10.4087 5.45354 10.4079 7.73845V7.73923Z"
                      fill="white"
                    />
                    <path
                      d="M3.65666 33.961C3.33047 31.4864 3.00586 29.0187 2.68359 26.5722C5.06725 26.708 7.39444 26.7104 9.78202 26.5698C9.46211 28.9984 9.13671 31.4661 8.80739 33.961H3.65666Z"
                      fill="white"
                    />
                    <path
                      d="M15.4604 15.9247H13.4688V13.9397H15.4604V15.9247Z"
                      fill="white"
                    />
                    <path
                      d="M15.4737 7.16919V9.13003H13.4727V7.16919H15.4737Z"
                      fill="white"
                    />
                  </svg>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};
